/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';

import { Restful } from 'service/restful';

import { MESSAGE_DELAY } from 'config/config';

import alertMsg from 'components/message';

const useGridConfig = (initialValues, setColumnDefs, isMessage = true) => {

  const [gridApi, setGridApi] = useState();
  const [gridNo] = useState(initialValues);
  const currentPage = useSelector(state => state.menuList?.current);

  const [getApi] = Restful();

  /***************************************************************************************
   * 설명 : 그리드 설정 불러오기
  ***************************************************************************************/
  const getGrid = () => {
    let params = {
      program: 'admin',
      service: 'common',
      action: 'getGrid',
      version: '1.0',
      menuNo: currentPage?.seq,
      gridNo: gridNo
    }

    getApi("get", params).then((response) => {
      if( gridApi !== undefined && response !== undefined && response.data.result ) {
        if (gridApi?.columnModel && response.data.result && response.data.data && response.data.data.length > 0) {

          const columns = JSON.parse(response.data.data[0].json);
          let newColumns = [];
          let otherColumns = [];

          columns.forEach((item) => {
            let tmp = gridApi.columnModel.columnDefs.filter((subItem) => subItem.field === item.field)
            if( tmp.length > 0 ) {
              tmp[0].width = item.actualWidth;
              newColumns.push(tmp[0]);
            }
          });

          gridApi.columnModel.columnDefs.forEach((item, index) => {
            let tmp = columns.filter((subItem) => subItem.field === item.field )

            if( tmp.length < 1 ) {
              otherColumns.push(item);
            }  
          });

          newColumns = newColumns.concat(otherColumns);

          setColumnDefs( newColumns );
        };
      }
    });
  }

  /***************************************************************************************
   * 설명 : 그리드 설정저장
  ***************************************************************************************/
  const setGridUpdate = (() => {

    if (!gridApi) {
      alertMsg("그리드 설정이 되어 있지 않습니다.", "E", MESSAGE_DELAY);
      return;
    };

    const data = gridApi.columnModel.displayedColumns?.map(column => ({
      field: column.colId,
      actualWidth: column.actualWidth
    }));

    let params = {
      program: 'admin',
      service: 'common',
      action: 'setGrid',
      version: '1.0',
      menuNo: currentPage.seq,
      gridNo: gridNo,
      data: data
    }

    getApi("post", params).then((response) => {
      if (response.data.result) {
        getGrid();

        if( isMessage )
          alertMsg(response.data.message, "S", MESSAGE_DELAY);

      } else {
        if( isMessage )
          alertMsg(response.data.message, 'E', MESSAGE_DELAY);
      }
    }).catch((e) => {
      alertMsg(e, "E", MESSAGE_DELAY);
    });

  });

  /***************************************************************************************
   * 설명 : 그리드 설정 로딩
  ***************************************************************************************/
  useEffect(() => {
    if( gridApi !== undefined ) {
      getGrid();
    }

  }, [gridApi]);

  return [setGridApi, setGridUpdate];
}

export default useGridConfig;